import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Callback from './components/Callback';
import Profile from "./components/Profile";
import Dashboard from "./components/dashboard/Dashboard";
import {DataProvider} from './components/dashboard/contexts/DataContext'; // Import DataProvider
import Modal from 'react-modal';
import {WebSocketProvider} from "./components/websockets/WebSocketProvider";
import {LoginProvider} from "./LoginContext";
import {StateUpdateProvider} from "./components/dashboard/contexts/StateUpdateContext";
import {SharingProvider} from "./components/dashboard/contexts/SharingContext";
import {PopupStackProvider} from "@dashboard/contexts/PopupStackContext";
import MonitoringDashboard from "@components/Monitoring/MonitoringDashboard";
import LoginPage from "./LoginPage";
import ErrorPage from "@dashboard/utils/ErrorPage";
import {RefreshProvider} from "@portfolio/context/RefreshContext";
import {GlobalEventsProvider} from "@dashboard/contexts/GlobalEventsContext";

const container = document.getElementById('root');
document.body.style.overflow = 'hidden';
const root = ReactDOM.createRoot(container);
Modal.setAppElement('#root');  // Replace '#root' with the appropriate selector for your app's root element

console.log("Debug Mode:", process.env.REACT_APP_DEBUG);
console.log("Environment:", process.env.REACT_APP_ENV);
console.log("Log Level:", process.env.REACT_APP_LOG_LEVEL);

if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    console.log("React DevTools Detected.");
} else {
    console.warn("React DevTools NOT Detected.");
}

// Global banner helpers
window.showGlobalBanner = (msg) => {
    window.dispatchEvent(new CustomEvent("global-banner", { detail: msg }));
};

window.clearGlobalBanner = () => {
    window.dispatchEvent(new CustomEvent("global-banner", { detail: null }));
};

root.render(
    <React.StrictMode>
        <PopupStackProvider>
            <Router>
                <Routes>
                    {/* Public route: no LoginProvider */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/error" element={<ErrorPage />} />

                    {/* Protected routes: wrapped in LoginProvider + other providers */}
                    <Route
                        path="/*"
                        element={
                            <LoginProvider>
                                <StateUpdateProvider>
                                    <WebSocketProvider>
                                        <SharingProvider>
                                            <DataProvider>
                                                <RefreshProvider>
                                                    <GlobalEventsProvider>
                                                        <ProtectedAppRoutes />
                                                    </GlobalEventsProvider>
                                                </RefreshProvider>
                                            </DataProvider>
                                        </SharingProvider>
                                    </WebSocketProvider>
                                </StateUpdateProvider>
                            </LoginProvider>
                        }
                    />
                </Routes>
            </Router>
        </PopupStackProvider>
    </React.StrictMode>
);

// ProtectedAppRoutes.js (or inline in index.js)
function ProtectedAppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/monitoring" element={<MonitoringDashboard />} />
            {/* add any other protected paths here */}
        </Routes>
    );
}
